export const HEADER_LIST = [
	{ value: 'Day', key: 'Head' },
	{ value: 'Mon', key: 'Td' },
	{ value: 'Tue', key: 'Td' },
	{ value: 'Wed', key: 'Td' },
	{ value: 'Thu', key: 'Td' },
	{ value: 'Fri', key: 'Td' },
	{ value: 'Sat', key: 'Td' },
	{ value: 'Sun', key: 'Td' },
];
